
import { useState, useRef, useEffect } from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom'

//Components
import { Grid } from "@mui/material";
import {
    Modal,
    ModalBody,
    ModalFooter,
    Button,
    Input,
    Form,
    Select,
} from "@gpstrackit/react-controls";
import CustomCard from 'Components/Card';
import CustomSelect from 'Components/Select';
import { copyToClipboard } from "Core/data/Helpers"

//Notification
import { NotificationManager } from "Components/Notifications";

//Styles
import './moveToOtherAccount.scss';

//Actions
import {
    moveToOtherAccountGetDeviceRequest,
    moveToOtherAccountSetDevice,
    moveToOtherAccountRequest,
    clearRedux,
} from 'Redux/actions';

import { getAccounts } from './redux/saga'

const MoveToOtherAccount = (props) => {
    const { tableRef, single, getDevice, account } = props;

    const { messages } = useIntl();
    const dispatch = useDispatch();
    const formRef = useRef(null);
    const navigate = useNavigate()

    //Redux States
    const { device, loading, openModal, result, selectedDevices } = useSelector(state => state.moveToOtherAccountRedux)

    //Local States
    const [devices, setDevices] = useState([]);
    const [accountFrom, setAccountFrom] = useState(account);
    const [accountTo, setAccountTo] = useState(null);
    const [serial, setSerial] = useState("");

    const searchDevice = () => {
        let deviceSearchCriteriaArr = serial.split(/[\s,;\t\n]+/);
        if (deviceSearchCriteriaArr.length > 1) {
            let criterias = [];

            deviceSearchCriteriaArr.forEach(criteria => {
                let escCriteria = criteria.trim();

                let regx = /[^a-zA-Z0-9]/g;
                escCriteria = escCriteria.replace(regx, '');

                if (devices && devices.length) {
                    for (let index in devices) {
                        let device = devices[index];

                        if (device.imei != escCriteria && device.esn != escCriteria) {
                            criterias.push(escCriteria?.trim());
                        }
                    }
                } else {
                    criterias.push(escCriteria?.trim());
                }
            });

            if (criterias.length) {
                dispatch(moveToOtherAccountGetDeviceRequest(criterias, accountFrom.id));
            }

        } else {

            let isValid = true;
            for (let index in devices) {
                let device = devices[index];
                if (device.esn.toString() === serial?.trim()) {
                    isValid = false;
                    break;
                }
            }

            if (isValid) {
                dispatch(moveToOtherAccountGetDeviceRequest(serial?.trim(), accountFrom.id));
            } else {
                NotificationManager.warning(
                    messages['move_to_other_account_device_is_already_added'],
                    messages['move_to_other_account_title'],
                    3000
                );
            }
        }
    }

    const closeModal = () => {
        setSerial("");
        setAccountFrom(null);
        setAccountTo(null);
        setDevices([]);
        dispatch(clearRedux("MOVE_TO_OTHER_ACCOUNT"));
    }

    const applyChanges = () => {
        let deviceValidation = devices.some((item) => item.status === 1)
        if (deviceValidation && accountTo?.status !== 1) {
            NotificationManager.error(
                messages['move_to_other_account_restriction_to_move'],
                messages['move_to_other_account_title'],
                3000
            );
            return
        }
        let unitIds = devices.map((item) => (item?.id))
        let payload = {
            newAccountId: accountTo?.id,
            unitIds
        }
        dispatch(moveToOtherAccountRequest(payload))
    }

    const getAccountsForSelect = (input, callback) => {
        if (!input) {
            callback([])
            return
        }
        getAccounts(input).then((response) => {
            if (response.result) {
                const { items } = response?.result
                const accounts = items?.length ? items.filter(item => item?.id !== account?.id) : []
                callback(accounts)
            }
        })
    }

    useEffect(() => {
        if (device) {
            dispatch(clearRedux("MOVE_TO_OTHER_ACCOUNT", { device: null }));
            if (!device?.total) {
                NotificationManager.warning(
                    messages['move_to_other_account_device_has_not_been_found'],
                    messages['move_to_other_account_title'],
                    3000
                );
            } else {
                let items = device.items;

                if (items?.length > 0) {
                    setSerial("");
                    let newItems = [...devices, ...items]
                    dispatch(moveToOtherAccountSetDevice(newItems))
                    setDevices([...newItems]);
                }
            }
        }
        if (selectedDevices && selectedDevices.length > 0) {
            let newDevices = selectedDevices.map((item) => ({ id: item?.id, imei: item?.imei, esn: item?.esn, deviceModel: item?.deviceModel, status: item?.status }));
            setDevices([...newDevices]);
            dispatch(clearRedux("MOVE_TO_OTHER_ACCOUNT", { selectedDevices: [] }))
        }
    }, [device, selectedDevices])

    useEffect(() => {
        if (result) {
            if (result?.updateMoveAccount) {
                closeModal();
                let transactionId = result?.updateMoveAccount?.transactionId;
                let message = messages["move_to_other_account_transaction_message"]
                NotificationManager.success(message, messages['move_to_other_account_title'], 10000, () => {
                    copyToClipboard(transactionId, messages['common_copied']);
                    navigate(`/app/transactions/list/${transactionId}`);

                }, null, '', null);
                getDevice && getDevice();
                tableRef && tableRef?.current?.getData();
            } else if (!result?.updateMoveAccount) {
                NotificationManager.error(
                    messages['move_to_other_account_error_message'],
                    messages['move_to_other_account_title'],
                    3000
                );
                dispatch(clearRedux("MOVE_TO_OTHER_ACCOUNT", { result: null }))
            }
        }
    }, [result])

    return (
        <Modal
            open={openModal}
            title={messages['move_to_other_account_title']}
            position="right"
            size="small"
            handleClose={closeModal}
            loading={loading}
        >
            <ModalBody>
                {
                    <div style={{ padding: '0 10px', height: '78vh' }}>
                        <Grid
                            container
                            spacing={1}
                        >
                            <Grid item xs={12}>
                                <Select
                                    id={`list-account-from`}
                                    value={accountFrom}
                                    options={[]}
                                    label={messages['move_to_other_account_account_from']}
                                    placeholder={messages['move_to_other_account_account_from']}
                                    onChange={(item) => {

                                    }}
                                    valueField="id"
                                    textField="name"
                                    disabled
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <CustomSelect
                                    async
                                    value={accountTo}
                                    onChange={(newaccount) => setAccountTo(newaccount)}
                                    label={messages['move_to_other_account_account_to']}
                                    placeholder={messages['move_to_another_account_account_to']}
                                    loadOptions={getAccountsForSelect}
                                    required
                                    getOptionLabel={e => e.name}
                                    getOptionValue={e => e.id}
                                    className="account-select-move-to-other-account"
                                />
                            </Grid>
                            <Grid item xs={10}>
                                <Form
                                    ref={formRef}
                                    onValidSubmit={() => searchDevice()}
                                >
                                    <Input
                                        label={messages['move_to_other_account_input']}
                                        placeholder={messages['move_to_other_account_input']}
                                        value={serial}
                                        required
                                        requiredMessage={messages['required_field']}
                                        onChange={(value) => setSerial(value)}
                                    />
                                </Form>
                            </Grid>
                            <Grid item xs={2}>
                                <div style={{ marginTop: 26 }}>
                                    <Button
                                        className="btn-dark-blue"
                                        onClick={() => formRef?.current?.submit()}
                                    >
                                        {messages['common_add']}
                                    </Button>
                                </div>
                            </Grid>
                        </Grid>
                        {
                            devices?.length > 0 &&
                            <Grid item xs={12} style={{ marginTop: 26 }}>
                                <label style={{ fontWeight: 700 }}>{messages['move_to_other_account_devices']}</label>
                            </Grid>
                        }
                        {devices.length > 0 ? devices.map((item, index) => {
                            return (
                                <CustomCard
                                    key={index}
                                    onClick={() => {
                                        let currentDevices = devices;
                                        let selected = currentDevices.findIndex((device) => device.id === item.id);
                                        if (selected > -1) currentDevices.splice(selected, 1);
                                        dispatch(moveToOtherAccountSetDevice(currentDevices));
                                    }}
                                >
                                    <div style={{ display: 'grid' }}>
                                        <div>
                                            <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['move_to_other_account_imei']}</label><span>{item.imei}</span>
                                        </div>
                                        <div>
                                            <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['move_to_other_account_serial']}</label><span>{item.esn}</span>
                                        </div>
                                        <div>
                                            <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['move_to_other_account_model']}</label><span>{item?.deviceModel?.name}</span>
                                        </div>
                                    </div>
                                </CustomCard>
                            )
                        }) : <div style={{ display: 'flex', justifyContent: 'center', marginTop: 25 }} ><span style={{ opacity: 0.6 }} >{messages['common_no_devices_added']}</span></div>}
                    </div>
                }

            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn-cancel"
                    onClick={() => closeModal()}
                >
                    {messages['common_cancel']}
                </Button>
                <Button
                    className="btn-dark-blue"
                    onClick={() => {
                        if (!accountTo) {
                            NotificationManager.warning(
                                messages['move_to_other_account_select_to_account'],
                                messages['move_to_other_account_title'],
                                3000
                            );

                        } else if (devices.length === 0) {
                            NotificationManager.warning(
                                messages['move_to_other_account_no_devices_added'],
                                messages['move_to_other_account_title'],
                                3000
                            );
                        } else {
                            //account from selected and devices added 
                            applyChanges();
                        }
                    }}
                >
                    {messages['move_to_other_account_change']}
                </Button>
            </ModalFooter>
        </Modal >
    )
}

export default MoveToOtherAccount;